import React, {Fragment, useEffect, useState} from 'react';
import {string, shape, number, func} from 'prop-types';
import {t} from 'translates';
import Icon from '../../../common/components/Icon';
import {cart} from 'actions';
import {useDispatch, useSelector} from "react-redux";
import Spinner from "../../../common/components/Spinner";
import langPrefix from 'common/helpers/langPrefix';
import ContentMessage from "../../../common/components/contentMessage";
import classNames from 'classnames';
import { get } from 'lodash';
import RequiredCourse from "./requiredCourse";
import LazyLoadImageComponent from "common/components/LazyLoadImage";
import ConfirmBox from "../../../common/components/ConfirmBox";
import {getProductToAnalytics} from "./Cart";

import { formatPriceWithDecimal } from 'common/helpers/priceFormat';

const AddToCartComponent = ({ item }) => {
  const { type, persons } = item;
  const isCursus = type === 'cursus';
  const isSession = type === 'sessions';
  const isGift = type === 'gc_products';
  const [product, setProduct] = useState(undefined);
  const [requiredCourses, setRequiredCourses] = useState(undefined);
  const [itemIsDeleted, setItemIsDeleted] = useState(false);
  const [deletedTitle, setDeletedTitle] = useState('');
  const cartData = useSelector((state) => state.cart);
  const {
    showAddToCartLoading,
    currency_symbol: symbol,
    currency_separator,
    currency_decimal_separator,
    currency_position
  } = cartData;
  const dispatch = useDispatch();
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);

  const closeModal = (e) => {
    e.preventDefault();
    dispatch(cart.hideAddToCart());
  };

  const handleCloseConfirm = () => {
    setIsOpenConfirm(false);
  };

  const onDeleteItem = (e, title) => {
    const id = isGift ? product.hash : product.id;
    e.preventDefault();
    let items = [];
    let productObj = getProductToAnalytics(product);

    items.push(productObj);

    window.dataLayer &&
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: product.currency_code,
        items: items,
      }
    });

    dispatch(cart.onDeleteSession(id));
    setItemIsDeleted(true);
    setDeletedTitle(title);
    handleCloseConfirm();

  };

  const onOpenConfirm = (e) => {
    e.preventDefault();
    setIsOpenConfirm(true);
  };

  useEffect(() => {
    dispatch(cart.fetch());
  }, []);

  useEffect(() => {
    const {
      id,
      persons,
      hash,
    } = item;
    if (cartData && cartData[type]) {
      setRequiredCourses(get(cartData, 'required_products', {}));
      const productData = cartData[type][id] || {};
      setProduct({
        ...productData,
        persons,
        id,
        type,
        hash,
      });
    }
  }, [cartData]);

  return (
    <div className="add-to-cart-container">
      {showAddToCartLoading ? <Spinner/> : (
        <Fragment>
          {itemIsDeleted ? (
            <ContentMessage
              message={`"${deletedTitle}" ${t('has been removed', DT_CART)}.`}
            />
          ) : (
            <Fragment>
              <div className="add-to-cart-container__title">
                {t('This product has been added to your basket', DT_CART)}
              </div>
              {product && (
                <Fragment>
                  <div className={classNames("cart-new-item add-to-cart-item", {
                    isSession: isSession,
                  })}>
                    <div className="cart-new-item__image">
                    <span
                      className="cart-new-item__label"
                      style={{
                        backgroundColor: isGift ? "#9FAFBA" : product.color,
                      }}
                    >
                      {isSession ? product.category_type : product.category_type}
                    </span>
                      <div className="cart-new-item__img">
                        {product.image && (
                          <LazyLoadImageComponent src={product.image.uri} alt={product.image.alt} title={product.image.title}/>
                        )}
                      </div>
                    </div>
                    <div className="cart-new-item__information">
                      <div className="info-block">
                        <div className="cart-new-item__title">
                          {isSession ? product.product_title : product.title}
                        </div>
                        <div className="info-block__inner">
                          <div className="cart-new-item__price">
                            { formatPriceWithDecimal((product.price + product.tax) * persons, symbol, currency_separator, currency_decimal_separator, currency_position)}
                            {/* {`${((product.price + product.tax) * persons).toFixed(2)} ${symbol}`} */}
                          </div>

                          <div className="session-item__information">
                            {isSession && (<Fragment>
                              <div className="session-item__information__item cart-new-item__date">
                                {product.display_date}
                              </div>
                              <div className="session-item__information__item cart-new-item__time">
                                {product.display_time}
                              </div>
                              <div className="session-item__information__item cart-new-item__language">
                                {product.language}
                              </div>
                            </Fragment>)}

                            {isCursus && (
                              <div className="session-item__information__item">
                                {product.count}
                              </div>
                            )}

                            {!isGift && (
                              <div className="session-item__information__item">
                                {product.persons} {product.persons === 1 ? t('participant', DT_CART) : t('participants', DT_CART)}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="session-item__remove icon-link">
                          <a href="#" onClick={(e) => onOpenConfirm(e)}>
                            <span className="cart-new-item__icon icon-link__icon">
                              <Icon name="trash-new"/>
                            </span>
                            {t("Remove", DT_CART)}
                          </a>
                        </div>
                        <ConfirmBox
                          options={{
                            text: isSession ? product.product_title : product.title,
                            confirm: t("Confirm removal", DT_CART),
                            cancel: t("Cancel removal", DT_CART),
                            btn: true
                          }}
                          isOpen={isOpenConfirm}
                          onClose={handleCloseConfirm}
                          onConfirm={(e) => onDeleteItem(e, isSession ? product.product_title : product.title)}
                          onCancel={handleCloseConfirm}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="add-to-cart__buttons">
                    <a href="#" className="button button-info" onClick={closeModal}>
                      {t('CONTINUE BOOKING', DT_CART)}
                    </a>
                    <a href={`/${langPrefix}cart`} className="button button-primary">
                      {t('View basket', DT_CART)}
                    </a>
                  </div>

                  {requiredCourses[product.id] && (
                    <Fragment>
                      <RequiredCourse
                        product={requiredCourses[product.id]}
                      />
                    </Fragment>
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
};

AddToCartComponent.propTypes = {
  item: shape({
    id: string.isRequired,
    persons: number.isRequired,
    type: string.isRequired,
  }).isRequired,
};

export default AddToCartComponent;
